import Vue from 'vue'
import Router from 'vue-router'

// 页面资源
import Home from '@/views/Home.vue'
import Detail from '@/views/Detail.vue'
import Column from '@/views/Column.vue'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};


let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: Home
    },
    {
      path: '/news',
      name: 'news',
      component: Column
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: Column
    },
    {
      path: '/tool',
      name: 'tool',
      component: Column
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail
    },
   
    {
      path: '*',
      redirect: '/index'
    },
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router